module.exports = __webpack_public_path__ + "img/744.3b33967d.jpg";